import { TableCell } from "@mui/material";
import React from "react";
import UserChip from "../../../../../chip/UserChip";

const TableCellStudent = ({ student, index }) => {
  return (
    <TableCell
      className={[
        "sticky left-0px max-w-250px min-w-250px z-10",
        index % 2 ? "bg-background-foreground" : "bg-background",
      ].join(", ")}
    >
      <UserChip
        name={student?.fullName}
        {...student}
        variant="outlined"
        className="border-none"
        maxWidth="250px"
      />
    </TableCell>
  );
};

export default TableCellStudent;
